<template>  
  <div>
    <q-card class="box" >
      <q-card-title>
        <q-toolbar color="primary">
        <q-toolbar-title>
          {{$t('global.EditGeoRegion')}}
        </q-toolbar-title>
        </q-toolbar>
      </q-card-title>
      <q-card-separator /> 
      
      <q-card-main>
        <q-toggle
        v-if="GeoRegion.GeoRegion.IdGeoRegionType == 4"
        color="pink"
        v-model="GeoRegion.GeoRegion.IsActive"
        label="Aktive"
      />
        <q-input :readonly="readonly" v-model="GeoRegion.GeoRegion.TypeDescription" :stack-label="$t('global.GeoRegionType')" />
        <p></p>
        <q-input v-model="GeoRegion.Label" :stack-label="$t('global.Name')" /> 
        <div v-if="GeoRegion.GeoRegion.IdGeoRegionType == 1">
          <q-input v-model="GeoRegion.GeoRegion.WeightFactor" type="number" :stack-label="$t('global.DistributionWeightFactor')" />
         <div v-if="false"> 
          <q-input v-model="GeoRegion.GeoRegion.GroundType" :stack-label="$t('global.Ground')" />
          <q-input v-model="GeoRegion.GeoRegion.PlantYear" type="number" :stack-label="$t('global.PlantingYear')" />
          <q-input v-model="GeoRegion.GeoRegion.PlantDistance" type="number" :stack-label="$t('global.PlantDistanceMeter')" />
          <q-input v-model="GeoRegion.GeoRegion.RowDistance" type="number" :stack-label="$t('global.RowsWidthMeters')" />
          <q-input v-model="GeoRegion.GeoRegion.PlantCapital" type="number" :stack-label="$t('global.PlantsCapital')" />
          <q-input v-model="GeoRegion.GeoRegion.AmortisationYear" type="number" :stack-label="$t('global.AmortizationYear')" />
         </div>
        </div>   
        <q-input v-model="GeoRegion.GeoRegion.Comment" type="textarea" :stack-label="$t('global.Comment')" /> 
        <div class="content" >
          <q-btn class="button" @click="saveGeoRegion()" color="primary" size="sm" :label="$t('global.Save')" />
           <q-btn v-if="GeoRegion.GeoRegion.IdGeoRegionType == 4" class="button" @click="dublicate()" color="primary" size="sm" :label="$t('global.DuplicateGeoregions')" />
          <q-btn class="button" v-if="GeoRegion.GeoRegion.CanDelete == true" @click="deleteGeoRegion()" color="primary" size="sm" :label="$t('global.Delete')" />
          <div v-if="$q.platform.is.desktop">
            <q-btn class="button" @click="editGeoRegion()" color="secondary" size="sm" :label="$t('global.EditGeoRegionMap')" icon="arrow_back"/>
            <q-btn v-if="GeoRegion.GeoRegion.IdGeoRegionType != 1" class="button" @click="addNewGeoRegionToNode()" color="secondary" size="sm" :label="$t('global.NewSubGeoRegion')" icon="arrow_back"/>
          </div>     
        </div>
        <div v-if="GeoRegion.GeoRegion.IdGeoRegionType == 1">
          <hr>
          <div class="q-table-title q-pb-sm">
            {{$t('global.AssignedProducts')}}
            <q-btn class="float-right" @click="newProduct" color="primary" size="sm" label="+" />
          </div>
          <q-table
            :data="productRows"
            :columns="columnsProduct"
            row-key="IdGeoRegionProduct"
            :dense=true
            selection="single"
            :selected.sync="productSelectedRow">
            
          <template slot="top-selection" slot-scope="props" >
            <div>
              <q-btn color="secondary" flat :label="$t('global.Remove')" @click="removeProduct()" />  
              <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteEntity()" v-if="productSelectedRow[0].CanDelete == true" />
              <q-btn color="secondary" flat :label="$t('global.Edit')" @click="editProduct()" />
            </div>
          </template>
          </q-table>
        </div>
      </q-card-main>
    </q-card> 

    <q-dialog
      v-model="dublicateDialog"
      stack-buttons
      prevent-close
      > 

      <span slot="title">{{$t('global.DuplicateGeoregions')}}</span>
      <div slot="body">
        <q-field
          :label="$t('global.NewName')"
        >
          <q-input v-model="dublicateName" />
        </q-field>
        <q-field
          label="Geo Region Suffix"
        >
          <q-input v-model="geoRegionPrefix" />
        </q-field>
      </div>
      <template slot="buttons" slot-scope="props">
        <q-btn :disable="!dublicateName" color="primary" :label="$t('global.Duplicate')" @click="geoTreeCopy()"/>
        <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
      </template>
    </q-dialog>
    <q-dialog
      v-model="newProductDialog"
      stack-buttons
      prevent-close>
      <span slot="title">{{$t('global.AssignProduct')}}</span>
      <div slot="body">
        <q-select
            v-model="newIdProduct"
            :float-label="$t('global.Product')"
            :options="optionsProduct"   
          />  
        <q-input v-model="newWeightFactor" type="number" :stack-label="$t('global.WeightFactor')" />
      </div>
      <template slot="buttons" slot-scope="props">
        <q-btn :disable="newIdProduct == null" color="primary" :label="$t('global.Assign')" @click="assignProduct" />
        <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
      </template>
    </q-dialog>
    <q-dialog    
      v-model="editProductDialog"
      v-if="productSelectedRow[0]"
      stack-buttons
      prevent-close>
      <span slot="title">{{$t('global.Edit')}} </span>
      <div slot="body" >
        <div slot="body" >
          {{productSelectedRow[0].Product}}
        </div>
        <q-input v-model="productSelectedRow[0].ProductWeightFactor" type="number" :stack-label="$t('global.WeightFactor')" />
      </div>
      <template slot="buttons" slot-scope="props">
        <q-btn :disable="productSelectedRow[0].ProductWeightFactor < 0.01" color="primary" :label="$t('global.Save')" @click="updateGeoProduct" />
        <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
      </template>
    </q-dialog>
    <q-dialog
      v-model="removeProductDialog"
      stack-buttons
      prevent-close>
      <span slot="title">{{$t('global.Remove')}}</span>
      <div slot="body" v-if="productSelectedRow[0]">
        {{productSelectedRow[0].Product}}
      </div>
      <template slot="buttons" slot-scope="props">
        <q-btn color="primary" :label="$t('global.Remove')" @click="unassignGeoProduct" />
        <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
      </template>
    </q-dialog>
  </div>
</template>
<script>
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialogGeoRegionNew',
  data () {
    return {
      dublicateName: null,
      dublicateDialog: false,
      newProductDialog: false,
      editProductDialog: false,
      removeProductDialog: false,
      selectedProduct: null,
      displayProduct: null,
      readonly: true,
      geoRegionName: null,
      selectedGeoRegionType: 1,
      optionsGeoRegionType: [],
      form: {
        SessionId: null,
        action: 'InsertGeoRegion',
      },
      groundType: null,
      plantYear: null,
      plantDistanceCm: null,
      rowDistanceCm: null,
      plantCapital: null,
      amortisationYear: null,
      comment:null,
      columnsProduct: [
                        { name: 'product',required: true, align: 'left', field: 'Product',sortable: true, label: this.$t('global.Product') },
                        { name: 'ProductWeightFactor',required: true, align: 'left', field: 'ProductWeightFactor',sortable: true, label: this.$t('global.WeightFactor') }
                      ],
      productRows: [],
      productSelectedRow: [],
      newIdProduct: null,
      optionsProduct: [],
      geoRegionPrefix: null,
      newWeightFactor: 1,
      isActive: true,
    }
  },
  methods: {

    dublicate(){
      this.dublicateDialog = true
    },

    deleteGeoRegion(){
      eventBus.$emit('deleteGeoRegion', this.GeoRegion.IdGeoRegion)
    },

    saveGeoRegion(){
        
        this.form.IsActive = true
        this.GeoRegion.GeoRegion.label = this.GeoRegion.Label
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "updateGeoRegion"
        this.form.GeoRegion = this.GeoRegion.GeoRegion
        if(this.GeoRegion.GeoRegion.IdGeoRegionType == 4){
          this.form.IsActive = this.isActive
        }

        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            console.log(response)
            if(response.status == 200){ 
              if(response.data == "OK"){
                  this.$q.notify({ message: 'Updated', type: 'positive' })
                }
                else{
                    this.$q.notify('Something Wrong.')
                }
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {        
          this.$q.notify('Something Wrong.')      
          console.log(e);
        })
    },

    loadProduct(){   
        this.GeoRegion.GeoRegion.label = this.GeoRegion.Label
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "getUnassignedProduct"
        this.form.IdGeoRegion = this.GeoRegion.IdGeoRegion
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            console.log(response)
            if(response.status == 200){ 
              this.optionsProduct = response.data
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {        
          this.$q.notify('Something Wrong.')      
          console.log(e);
        })
    },


    getProductByGeoRegion(){
        if(this.GeoRegion.GeoRegion.IdGeoRegionType == 1){
          this.GeoRegion.GeoRegion.label = this.GeoRegion.Label
          this.form.SessionId = this.$store.state.session.SessionId
          this.form.action = "getProductByGeoRegion"
          this.form.IdGeoRegion = this.GeoRegion.IdGeoRegion
          axios.post(this.$apiUrl,
          qs.stringify(this.form),
          {
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(response => {
              console.log(response)
              if(response.status == 200){ 
                this.productRows = response.data
              }
              else{
                  this.$q.notify('Something Wrong.')
              }
          })
          .catch(e => {        
            this.$q.notify('Something Wrong.')      
            console.log(e);
          })
        }
    },

    addNewGeoRegionToNode(IdGeoRegion){
      eventBus.$emit('addGeoRegionDialog', { IdParent: this.GeoRegion.IdGeoRegion, Label: this.GeoRegion.Label })
    },
    editGeoRegion(){
      eventBus.$emit('editObject', this.GeoRegion)
    },

    geoTreeCopy(){   
        this.dublicateDialog = false 
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "geoTreeCopy"
        this.form.IdGeoRegion = this.GeoRegion.IdGeoRegion
        this.form.Name = this.dublicateName
        this.form.GeoRegionPrefix = this.geoRegionPrefix
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
            if(response.data == "OK"){
              this.$q.notify({ message: this.$t('global.GeoregionsDuplicated'), type: 'positive' })   
              eventBus.$emit('loadGeoRegion', null)
            }   
            else
              this.$q.notify('Something Wrong.')
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
    },
    removeProduct(){
      this.removeProductDialog = true
    },

    unassignGeoProduct(){
      this.removeProductDialog = false
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "unassignProduct"
      this.form.IdGeoRegionProduct = this.productSelectedRow[0].IdGeoRegionProduct
      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          console.log(response)
          if(response.status == 200){ 
            if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
                this.getProductByGeoRegion()
              }
              else{
                  this.$q.notify('Something Wrong.')
              }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {        
        this.$q.notify('Something Wrong.')      
        console.log(e);
      })   
    },    


    updateGeoProduct(){
      this.editProductDialog = false
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "updateGeoProduct"
      this.form.IdGeoRegionProduct = this.productSelectedRow[0].IdGeoRegionProduct
      this.form.ProductWeightFactor = this.productSelectedRow[0].ProductWeightFactor
      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          console.log(response)
          if(response.status == 200){ 
            if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.WorkChanged'), type: 'positive' })
                this.getProductByGeoRegion()
              }
              else{
                  this.$q.notify('Something Wrong.')
              }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {        
        this.$q.notify('Something Wrong.')      
        console.log(e);
      })   
    },    




    assignProduct(){
      this.newProductDialog = false
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "assignProduct"
      this.form.IdGeoRegion = this.GeoRegion.IdGeoRegion
      this.form.IdProduct = this.newIdProduct
      this.form.WeightFactor = this.newWeightFactor

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          console.log(response)
          if(response.status == 200){ 
            if(response.data == "OK"){
                this.$q.notify({ message: 'Updated', type: 'positive' })
                this.newIdProduct = null
                this.getProductByGeoRegion()
              }
              else{
                  this.$q.notify('Something Wrong.')
              }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {        
        this.$q.notify('Something Wrong.')      
        console.log(e);
      })  
    },  
    newProduct(){
      this.loadProduct()
      this.newProductDialog = true
    },  
    editProduct(){
      this.editProductDialog = true
    }
  },

  props: ['GeoRegion'],
  created () {
    this.getProductByGeoRegion()
  },
  watch: {
    GeoRegion: function (newValue, oldValue) {
      this.getProductByGeoRegion()
      this.productSelectedRow = []
    }
  },
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

</script>

<style>
.box{
  padding-left: 0px;
}
.content{
  padding: 0px;
  margin-left: 0px;
}
.button{
  margin-top: 10px;
  margin-left: 10px
}
</style>
